module.exports = __webpack_public_path__ + "img/banner-standapp.13ca34fb.svg";